
import request from '@/utils/request'

// 获取用户家人SOS预警信息
export function healthSos(data) {
  return request({
    url: `/api/v1/sospostion/${data.accountId}/family?page=${data.page}&row=${data.row}&accountId=${data.accountId}`,
    baseURL: 'other',
    method: 'get',
    data
  })
}

// 处理用户预警信息查看状态
export function delectHealthSos(data) {
  return request({
    url: `/api/v1/sospostion/${data.id}/read?id=${data.id}`,
    baseURL: 'other',
    method: 'get',
    data
  })
}

export function healthHistorySos(data) {
  return request({
    url: `/api/v1/sos/position/page?page=${data.page}&row=${data.row}&accountId=${data.accountId}&read=${data.read}`,
    baseURL: 'other',
    method: 'get',
    data
  })
}
